import Keycloak from 'keycloak-js'
import secureLocalStorage from 'react-secure-storage'
import { isProdEnvironment } from './config/environment'

const fallbackUrl = isProdEnvironment
  ? process.env.REACT_APP_KEYCLOAK_PROD_URL || 'https://auth.ocplanet.cloud/auth'
  : process.env.REACT_APP_KEYCLOAK_DEV_URL || 'https://auth.netengi.ua/auth'

const fallbackRealm = isProdEnvironment ? 'onecloud' : 'Onecloud'

const clientId = isProdEnvironment
  ? process.env.REACT_APP_CLIENT_PROD || 'onecloud_main'
  : process.env.REACT_APP_CLIENT_DEV || 'onecloud_main'

const keycloakConfig = {
  url: fallbackUrl.replace(/\/+$/, ''),
  realm: fallbackRealm,
  clientId,
}

const keycloak = new Keycloak(keycloakConfig)

let initialization: Promise<boolean> | undefined

export const initializeKeycloak = (): Promise<boolean> => {
  if (!initialization) {
    // Remove credentials left behind by older versions of the console.
    localStorage.removeItem('cloud-jwt')
    secureLocalStorage.removeItem('userToken')

    keycloak.onTokenExpired = () => {
      void keycloak.updateToken(170).catch(() => {
        console.error('Keycloak token refresh failed')
      })
    }

    // The default adapter otherwise includes location.hash in redirect_uri.
    // Leave the current URL intact so init can still consume an OAuth callback.
    const redirectUri = new URL(window.location.href)
    redirectUri.hash = ''

    // Keep the same promise even on failure: an instance can only be initialized once.
    initialization = keycloak.init({
      onLoad: 'login-required',
      checkLoginIframe: false,
      pkceMethod: 'S256',
      redirectUri: redirectUri.toString(),
    })
  }

  return initialization
}

export default keycloak
